<template>
  <div class="centered">
    <div>
      <h1>This page is unavailable</h1>
      <p>
        The page you want to visit is unavailable. Click
        <router-link :to="link">here</router-link> to continue where you left
        off.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from
    })
  },
  data: function() {
    return {
      previousRoute: undefined
    }
  },
  computed: {
    link: function() {
      return this.previousRoute ? this.previousRoute : ""
    }
  }
}
</script>

<style lang="scss" scoped>
div.centered {
  width: 100%;
  height: 100%;
  flex-direction: columns;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
